<template>
    <div>

        <form class="trax-form">

            <trax-ui-toggle :text="lang.polaris.common.daily_digest" v-model="preferences.daily_digest">
            </trax-ui-toggle>

            <!-- Submit button -->

            <div class="trax-form-actions text-right">
                <button type="button" class="btn btn-round btn-primary" @click="savePreferences">
                    {{ lang.polaris.form.save }}
                </button>
            </div>

        </form>


    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-account-user-edit'},
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                endpoint: app_url+'polaris/api/front/users/preferences',
                preferences: {
                    daily_digest: data.notifications_default.digest
                },
                bus: this.$bus
            }
        },

        created: function() {
            this.setPreferences();
        },

        methods: {

            setPreferences() {
                if (!this.user.meta.preferences) return;
                for (var prop in this.user.meta.preferences) {
                    if (this.preferences[prop] !== undefined) {
                        this.preferences[prop] = this.user.meta.preferences[prop];
                    }
                }
            },

            savePreferences() {
                var that = this;
                axios.post(this.endpoint, this.preferences)
                    .then(function (response) {
                        that.bus.$emit(that.id+'-toastr-success');
                    })
                    .catch(function (error) {
                        that.bus.$emit(that.id+'-toastr-error');
                    });
            }
        }
    }
</script>
